import { render, staticRenderFns } from "./ModalAppointment.vue?vue&type=template&id=187626c4&"
import script from "./ModalAppointment.vue?vue&type=script&lang=js&"
export * from "./ModalAppointment.vue?vue&type=script&lang=js&"
import style0 from "./ModalAppointment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports